export enum LinkVariant {
  primary = 'primary',
  external = 'external',
}

export const link = {
  primary: { default: null, hover: null },
  external: { default: null, hover: null },
};
